module.exports = {
  footerText: 'Made by TMT © 2024',
}
